import { MAX_ITEMS_IN_PAGE } from '../../actions/commonActions';

const initState = {
  costCenters: [],
  costCenter: {},
  currentPage: 1, 
  totalPages: 0, 
  numItems: 0, 
  min: 1, 
  max: MAX_ITEMS_IN_PAGE,
  costCenterFilter: ''
}

const costCenterReducer = (state = initState, action) => {
  switch (action.type) {
    case 'FETCH_COST_CENTERS': 
      return {
        ...state, 
        costCenters: action.costCenters 
      }
    case 'SET_COST_CENTERS_PAGINATION':
      return {
        ...state, 
        numItems: action.numItems, 
        min: action.min, 
        totalPages: action.totalPages,
        currentPage: typeof(action.currentPage) !== "undefined" ? action.currentPage : state.currentPage, 
        max: action.max 
      }
    case 'RESET_COST_CENTERS_PAGINATION':
      return {
        ...state, 
        currentPage: 1, 
        totalPages: 0, 
        numItems: 0, 
        min: 1, 
        max: MAX_ITEMS_IN_PAGE
      }
    case 'COST_CENTER_FILTER':
      return {
        ...state, 
        costCenterFilter: action.filter
      }
    case 'SET_COST_CENTER_FIELD_CHANGE':
      return {
        ...state, 
        costCenter: Object.assign(state.costCenter, action.value)
      }
    case 'SET_COST_CENTER': 
      return {
        ...state, 
        costCenter: action.costCenter
      }
    case 'RESET_COST_CENTER':
      return {
        ...state, 
        costCenter: {}
      }
    default: 
      return state;
  }
} 

export default costCenterReducer

